import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";

import config from "../config/config";

function Container({ onPress, children }) {
    return (
        <TouchableOpacity underlayColor={config.colors.tertiary} onPress={onPress}>
            <View style={styles.component}>{children}</View>
        </TouchableOpacity>
    );
}

const styles = StyleSheet.create({
    component: {
        flexDirection: "column",
        backgroundColor: config.colors.white,
        borderRadius: 20,
        shadowColor: config.colors.black,
        shadowOffset: { width: -2, height: 4 },
        shadowOpacity: 0.7,
        shadowRadius: 5,
        elevation: 10,
        padding: 10,
    },
});

export default Container;
